import {
    SET_CUSTOMER,
} from './types';

export default {
  [SET_CUSTOMER](state: { customer: any; }, customer: any) {
    state.customer = customer;
  },
};
